import { TTextareaVariable, TTextareaVariableAddable, TVariableStore } from '@honestica/curecall-ui'
import { TContent } from '../../../../contents/_components/content.type'
import { getTranslatedTextareaVariable } from './sms.util'

const PATIENT_VARIABLE: TTextareaVariableAddable = {
  label: 'patient-name', // Nom du patient
  isReadOnly: false,
  apiVariableSyntax: '${patient.prettyName}',
  example: {
    average: 'Martine Dupont', // average helps to count caracters but is never showed to user
    given: 'patient-name-example-1',
    result: 'patient-name-example-2',
  },
}

// Note : cette variable apparaît de manière conditionnelle
// Voir src/pages/configuration/followups/[followupId]/messages/_components/message-fields.component.tsx
const MED_EVENT_LOCATION_NAME_VARIABLE: TTextareaVariableAddable = {
  label: 'location-name', // Nom de l'établissement
  isReadOnly: false,
  apiVariableSyntax: '${context.patientMedEvent.Location.name}',
  example: {
    average: 'Clinique de Saint-Sauveur',
    given: 'location-name-example-1',
    result: 'location-name-example-2',
  },
}
// Note : cette variable apparaît de manière conditionnelle
// Voir src/pages/configuration/followups/[followupId]/messages/_components/message-fields.component.tsx
const MED_EVENT_LOCATION_ADRESS_VARIABLE: TTextareaVariableAddable = {
  label: 'location-address', // Adresse de l'établissement
  isReadOnly: false,
  apiVariableSyntax: '${context.patientMedEvent.Location.address}',
  example: {
    average: 'Centre de vision, 15 rue de Montmorency, 2ème étage droite, 75003 PARIS, FRANCE',
    given: 'location-address-example-1',
    result: 'location-address-example-2',
  },
}
const MED_EVENT_LOCATION_PHONE_VARIABLE: TTextareaVariable = {
  label: 'location-phone', // Téléphone du lieu du rendez-vous
  isReadOnly: true,
  example: {
    average: '33600000000',
    given: 'location-phone-example-1',
    result: 'location-phone-example-2',
  },
}
const MED_EVENT_FLOOR_VARIABLE: TTextareaVariable = {
  label: 'location-floor',
  isReadOnly: true,
  apiVariableSyntax: '${patientMedEvent.metadata.floor}',
  example: { average: '2ème étage', given: 'location-floor-example-1', result: 'location-floor-example-2' },
}

const SECRETARIA_VARIABLE: TTextareaVariable = {
  label: 'secretariat-information', // Informations de secretariat
  isReadOnly: true,
  example: {
    average: 'SOPHIE sophie@hopital.com',
    given: 'secretariat-information-example-1',
    result: 'secretariat-information-example-2',
  },
}
const SECRETARIAT_PHONE_VARIABLE: TTextareaVariable = {
  label: 'secretariat-phone', // Téléphone du secretariat
  isReadOnly: true,
  example: {
    average: '33600000000',
    given: 'secretariat-phone-example-1',
    result: 'secretariat-phone-example-2',
  },
}

const DOCTOR_VARIABLE: TTextareaVariable = {
  label: 'doctor-name', // Nom du docteur
  isReadOnly: true,
  example: {
    average: 'Dr.Bernard',
    given: 'doctor-name-example-1',
    result: 'doctor-name-example-2',
  },
}

const DATE_ONLY_VARIABLE: TTextareaVariableAddable = {
  label: 'appointment-date', // Date du rendez-vous DD/MM/YYYY
  isReadOnly: false,
  apiVariableSyntax: '${context.patientMedEvent.date; date; fr; DD/MM/YYYY}',
  example: {
    average: '10/01/30',
    given: 'appointment-date-example-1',
    result: 'appointment-date-example-2',
  },
}
const DATE_WITH_TIME_VARIABLE: TTextareaVariableAddable = {
  label: 'appointment-date-with-time', // Date et heure du rendez-vous DD/MM/YYYY à HH:mm
  isReadOnly: false,
  apiVariableSyntax: '${context.patientMedEvent.date; date; fr; DD/MM/YY à HH:mm}',
  example: {
    average: '21/01 à 09:00',
    given: 'appointment-date-with-time-example-1',
    result: 'appointment-date-with-time-example-2',
  },
}
const DATE_CONVOCATION: TTextareaVariable = {
  label: 'convocation-date', // Date et heure de convocation
  isReadOnly: true,
  example: {
    average: 'Samedi 23 decembre à 07:30',
    given: 'convocation-date-and-time-example-1',
    result: 'convocation-date-and-time-example-2',
  },
}
const CONVOCATION_DATE_AND_TIME_VARIABLE: TTextareaVariableAddable = {
  label: 'convocation-date-and-time',
  isReadOnly: false,
  apiVariableSyntax: '${context.patientMedEvent.convocationDate; date; fr; DD/MM/YY à HH:mm}',
  example: {
    average: '21/02/2025 à 06:00',
    given: 'convocation-date-and-time-example-1',
    result: 'convocation-date-and-time-example-2',
  },
}
const CONVOCATION_DATE_VARIABLE: TTextareaVariableAddable = {
  label: 'convocation-date',
  isReadOnly: false,
  apiVariableSyntax: '${context.patientMedEvent.convocationDate ; date; fr}',
  example: {
    average: '21/01/2025',
    given: 'convocation-date-example-1',
    result: 'convocation-date-example-2',
  },
}
const CONVOCATION_TIME_VARIABLE: TTextareaVariableAddable = {
  label: 'convocation-time',
  isReadOnly: false,
  apiVariableSyntax: '${context.patientMedEvent.convocationDate ; date; fr; HH:mm}',
  example: {
    average: '07:30',
    given: 'convocation-time-example-1',
    result: 'convocation-time-example-2',
  },
}

const DEFAULT_CONTENT_VARIABLE: TTextareaVariableAddable = {
  label: 'content-name',
  isReadOnly: false,
  apiVariableSyntax: '',
  example: {
    average: 'https://short.url',
    given: 'contents-example-1',
    result: 'contents-example-2',
  },
}

const COMMUNICATION_CHANNEL_VARIABLE: TTextareaVariableAddable = {
  label: 'communication-channel',
  isReadOnly: false,
  apiVariableSyntax: '${communicationChannel}',
  example: {
    average: '09 39 00 00 00',
    given: 'communication-channel-example-1',
    result: 'communication-channel-example-2',
  },
}

const UNKNOWN_VARIABLE: TTextareaVariable = {
  label: 'unknown-variable',
  isReadOnly: true,
  apiVariableSyntax: '',
  example: {
    average: 'variable-inconnue',
    given: 'unknown-variable-example-1',
    result: 'unknown-variable-example-2',
  },
}

const getContentVariables = (t: any, contents: TContent[]) => {
  return contents?.map((content: TContent) => ({
    label: content.name || content.label || t('pages.configuration.messages.content-name'),
    isReadOnly: false,
    apiVariableSyntax: '${content; ' + content.label + '; fr}',
    example: {
      average: DEFAULT_CONTENT_VARIABLE.example.average,
      given: t('pages.configuration.messages.contents-example-1'),
      result: t('pages.configuration.messages.contents-example-2'),
    },
  }))
}

const getDefaultContentVariable = (t: any, name?: string) => {
  return {
    label: name || t(`pages.configuration.messages.${DEFAULT_CONTENT_VARIABLE.label}`),
    isReadOnly: false,
    apiVariableSyntax: DEFAULT_CONTENT_VARIABLE.apiVariableSyntax,
    example: {
      average: DEFAULT_CONTENT_VARIABLE.example.average,
      given: t(`pages.configuration.messages.${DEFAULT_CONTENT_VARIABLE.example.given}`),
      result: t(`pages.configuration.messages.${DEFAULT_CONTENT_VARIABLE.example.result}`),
    },
  }
}

const buildVariableStore = (t: any): TVariableStore => {
  return {
    patient: {
      prettyName: { _variable: getTranslatedTextareaVariable(PATIENT_VARIABLE, t) },
      firstname: { _variable: getTranslatedTextareaVariable(PATIENT_VARIABLE, t) },
      lastname: { _variable: getTranslatedTextareaVariable(PATIENT_VARIABLE, t) },
    },
    project: {
      secretariat: {
        phone: { _variable: getTranslatedTextareaVariable(SECRETARIAT_PHONE_VARIABLE, t) },
        _variable: getTranslatedTextareaVariable(SECRETARIA_VARIABLE, t),
      },
    },
    additionalContext: {
      patientMedEvent: {
        Location: {
          name: { _variable: getTranslatedTextareaVariable(MED_EVENT_LOCATION_NAME_VARIABLE, t) },
          address: { _variable: getTranslatedTextareaVariable(MED_EVENT_LOCATION_ADRESS_VARIABLE, t) },
          phone: { _variable: getTranslatedTextareaVariable(MED_EVENT_LOCATION_PHONE_VARIABLE, t) },
        },
        metadata: { floor: { _variable: getTranslatedTextareaVariable(MED_EVENT_FLOOR_VARIABLE, t) } },
      },
      doctor: { _variable: getTranslatedTextareaVariable(DOCTOR_VARIABLE, t) },
      patientFollowup: {
        MedicalStaffMember: { _variable: getTranslatedTextareaVariable(DOCTOR_VARIABLE, t) },
      },
      communicationChannel: { _variable: getTranslatedTextareaVariable(COMMUNICATION_CHANNEL_VARIABLE, t) },
    },
    date: {
      withTime: { _variable: getTranslatedTextareaVariable(DATE_WITH_TIME_VARIABLE, t) },
      _variable: getTranslatedTextareaVariable(DATE_ONLY_VARIABLE, t),
      convocationDate: { _variable: getTranslatedTextareaVariable(DATE_CONVOCATION, t) },
    },
    convocation: {
      dateAndTime: { _variable: getTranslatedTextareaVariable(CONVOCATION_DATE_AND_TIME_VARIABLE, t) },
      date: { _variable: getTranslatedTextareaVariable(CONVOCATION_DATE_VARIABLE, t) },
      time: { _variable: getTranslatedTextareaVariable(CONVOCATION_TIME_VARIABLE, t) },
    },
    _defaultVariable: getTranslatedTextareaVariable(UNKNOWN_VARIABLE, t) as any, // defaultVariable is a exception
  }
}
export { buildVariableStore, getContentVariables, getDefaultContentVariable }
